module.exports = "bundles/c853c2d2d8f787e152d34a79536b9db5.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/pie-charts/pie-chart-0.png
// module id = 127
// module chunks = 0